<template>
  <div v-if="desc" class="ds-gen-docs" v-html="desc"></div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { EventDoc, GlueDocs } from "./glue-documentation-types";

@Component({ name: "general-docs" })
export default class GlueDocEvents extends Vue {
  @Prop(String)
  public readonly componentName!: string;

  get desc(): string | null {
    const doc: GlueDocs = window[this.componentName + "-docs"];
    if (doc != null) {
      if (typeof doc.general !== "string") {
        return null;
      }
      if (typeof (window as any).marked === "function") {
        return (window as any).marked(doc.general);
      }
      return doc.general;
    }
    return null;
  }
}
</script>
